import { Component, effect, inject } from '@angular/core';
import {FormBuilder, FormGroup, Validators, ReactiveFormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatButtonModule} from '@angular/material/button';
import {DatevIntegrationService} from "../services/datev-integration.service";

@Component({
  selector: 'app-set-client-form',
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule
  ],
  templateUrl: './set-client-form.component.html',
  styleUrl: './set-client-form.component.scss'
})

export class SetClientFormComponent {
  clientForm: any;
  private formBuilder = inject(FormBuilder);
  private datevService = inject(DatevIntegrationService);

  constructor() {
    this.clientForm = this.formBuilder.group({
      berater: ['', [Validators.required]],
      client: ['', [Validators.required]],
    });

    effect(() => {
      const moreClients = this.datevService.hasMoreClients();
      if(moreClients) {
        this.clientForm.patchValue({berater: this.datevService.berater()})
      }
    });
  }


  submitClientForm() {
    this.datevService.setLoading(true);
    const data = this.clientForm.value;
    const clientId = data.berater + '-' + data.client;
    sessionStorage.setItem('clientId', clientId);

    const datevUrl = this.datevService.getDatevUrl(clientId);
    window.location.href = datevUrl;
  }
}
